// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
import { AppEnvironmentOptions } from './environnement.interface';

export const environment: AppEnvironmentOptions = {
  production: false,
  config: {},
  igo: {
    app: {
      forceCoordsNA: true,
      install: {
        enabled: false,
        promote: false
      },
      pwa: {
        enabled: false
      }
    },
    language: {
      prefix: './locale/'
    },
    auth: {
      hostsWithCredentials: [
        {
          domainRegFilters: '(https?:\/\/)?localhost(:\d{1,5})?(\/.*)?',
          withCredentials: true
        }
      ]
    }
  }
};
